import types from '../types';

export const toggleMenuState = () => ({
	type: types.layout.TOGGLE_MENU_STATE,
	payload: {}
});
